import { render } from "./PublicShareAuthRequestPasswordButton.vue?vue&type=template&id=3be16eb2"
import script from "./PublicShareAuthRequestPasswordButton.vue?vue&type=script&lang=js"
export * from "./PublicShareAuthRequestPasswordButton.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__